import React from "react";

export default function Workinprogrees() {
  return <div className="wip-label">Work In Progress</div>;
}
